module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"hint":"Devices are loaded ...","logout":"Back to login"},"de":{"hint":"Geräte werden geladen ...","logout":"Zurück zum Login"},"fr":{"hint":"Les appareils sont chargés ...","logout":"Retour à la connexion"},"it":{"hint":"I dispositivi sono caricati ...","logout":"Torna al login"}}')
  delete Component.options._Ctor
}
